// Every message of the panel is an alert window of the host app (its ExtendScript alert), not a browser alert of
// the panel: window.alert is replaced when the panel starts (index.js imports this first). The arguments are joined
// (alert("Error writing file:", name) showed only the first one). Outside CEP (npm start in a browser) the browser
// alert stays.
const browserAlert = window.alert ? window.alert.bind(window) : null;

export function hostAlert(...args) {
  const message = args.map((a) => (a instanceof Error ? a.message : String(a))).join(" ");
  const cep = window.__adobe_cep__;
  if (cep && cep.evalScript) {
    cep.evalScript("alert(" + JSON.stringify(message) + ")", () => {});
  } else if (browserAlert) {
    browserAlert(message);
  }
}

window.alert = hostAlert;
